
import {initWebComponent} from "@/helpers/web-component-helper";
import {initBoostrapSlider} from "@/helpers/bootstrap-slider-helper";
import {clearInfoCharacteristics} from "@/helpers/layer/info/layer-info-characteristics-helper";

export class LayerInfoCharacteristicsComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = ``;

        initWebComponent(this, template)

        clearInfoCharacteristics()
    }
}

